export const isInboxScreen = () => {
  if (typeof window === "undefined") return false;
  return window.location.pathname.includes("/inbox");
};

export const formatPickupDateAndTime = (utcString: string): string => {
  const date = new Date(utcString);

  const options: Intl.DateTimeFormatOptions = {
    month: "short", // "Jun"
    day: "numeric", // "18"
    year: "numeric", // "2025"
    hour: "numeric", // "1"
    minute: "2-digit", // "41"
    hour12: true, // "AM/PM"
  };

  const formatted = new Intl.DateTimeFormat("en-US", options).format(date);

  // The format is like "Jun 18, 2025, 1:41 PM"
  const parts = formatted.split(", ");
  return `${parts[0]} ${parts[1]} at ${parts[2]}`;
};

export const urlBase64ToUint8Array = (base64: string): Uint8Array | any => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
};

export const fullNameGenerator = (firstName: any, lastName: any) => {
  return `${firstName ?? ""} ${lastName ?? ""}`;
};

export const slugify = (text: string) => {
  return text.toLowerCase().trim().replace(/\s+/g, "-"); // replace spaces with -
};

export const getCurrencySymbol = (currency?: string): string => {
  switch (currency?.toLowerCase()) {
    case "ph":
    case "php":
      return "\u20b1";
    case "usd":
    default:
      return "$";
  }
};

export const getRideCurrencySymbol = (ride?: {
  currency?: string;
  paymentMethodName?: string;
}): string => {
  const currency = ride?.currency?.toLowerCase();
  const paymentMethodName = ride?.paymentMethodName?.toLowerCase();

  if (currency === "php" || currency === "ph" || paymentMethodName === "gcash") {
    return "\u20b1";
  }

  return getCurrencySymbol(currency);
};

export const stripHTML = (html: string): string => {
  if (typeof window === "undefined" || !html) return html;
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};
